import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import FundsService from 'donor-elf-web/services/funds-service';

let DONOR_ELF_FIELD_MAPPING: { [index: string]: string } = {
  name: 'Display Name',
  first_name: 'First Name',
  last_name: 'Last Name',
  mailing_name: 'Mailing Name',
};

export default class MailchimpConnectedToFundController extends Controller {
  @service declare fundsService: FundsService;
  @service declare currentUser: any;

  @tracked changesSaved = false;

  get mailchimpFundSetting() {
    return this.model.mailchimpFundSetting;
  }

  get changeset() {
    return this.model.mailchimpFundSettingChangeset;
  }

  get listName() {
    let mcSetting = this.model.mailchimpSetting;
    let mcFund = this.mailchimpFundSetting;
    let listId = mcFund.mailchimpListId;
    return mcSetting.lists.find((x: any) => x.id === listId)?.name;
  }

  get formattedMergeVars() {
    return (this.mailchimpFundSetting.mergeVars || []).map(
      (x: { name: string; attribute: string }) => {
        return {
          mailchimpField: x.name,
          donorElfField: DONOR_ELF_FIELD_MAPPING[x.attribute],
        };
      },
    );
  }

  get syncGroupsChanged() {
    return this.changeset.isDirty;
  }

  @action
  templateDidInsert() {
    this.changesSaved = false;
  }

  @action
  handleSave() {
    this.changesSaved = true;
    this.changeset.save();
  }
}
